import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import Button from 'ui-lib/components/Button';
import { useSnackbarContext } from 'ui-lib/components/Snackbar/SnackbarProvider';
import HttpError from 'web-shared/services/http-service/HttpError';
import { LoginURLState, SSOService } from 'web-shared/services/sso-auth-service/SSOService';

import { PublicCompanySSOConfig } from '../../../../../../../../frontend/global/modules/companies/api/sso-config/types/PublicCompanySSOConfig';

interface Props {
  ssoService: SSOService;
  subdomain: string;
  testID: string;
  config: PublicCompanySSOConfig;
  disabled?: boolean;
}

const SsoLoginButton = ({
  config,
  disabled,
  ssoService,
  subdomain,
  testID,
}: Props) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);

  const location = useLocation<LoginURLState | null>();
  const locationState = location.state;

  const { showHttpErrorSnackbar } = useSnackbarContext();

  if (!ssoService.isAvailable()) return null;

  const handleClick = async () => {
    setLoading(true);

    try {
      const authUrl = await ssoService.getLoginUrl({
        ssoDomain: config.domain,
        state: JSON.stringify({
          companySubdomain: subdomain,
          from: locationState?.from,
        }),
      });

      window.location.assign(authUrl);
    } catch (error) {
      if (HttpError.isHttpError(error)) {
        showHttpErrorSnackbar(error);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      fullWidth
      type='button'
      size='large'
      variant='tonal'
      disabled={disabled || loading}
      loading={loading}
      onClick={handleClick}
      testID={`${testID}-sso-login-button`}
    >
      {t('auth.label_ssoLogin')}
    </Button>
  );
};

export default SsoLoginButton;
